module.exports = __webpack_public_path__ + "static/media/clayton.471f7c7d.jpg";